/** @jsx jsx */
import { jsx, Container, Flex, Box, Styled } from "theme-ui"
import { graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"

import PageIntro from "../components/pageIntro"
import ReferralIcon from "../images/icons/referral.inline.svg"
import ReferralForm from "../components/referralForm"

const ReferralProgram = ({ data: { bg, referralProgram } }) => {
  return (
    <Layout>
      <SEO title="Referral Program" />
      <section
        sx={{
          position: 'relative',
          mb: 5
        }}>
        <Img
          fluid={referralProgram.hero.childImageSharp.fluid} />
        <PageIntro>
          <Flex
            sx={{
              flexDirection: 'column',
              alignItems: 'center'
            }}>
            <Flex
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap'
              }}>
              <Box
                sx={{
                  mr: 3
                }}>
                <ReferralIcon sx={{ width: '120px' }} />
              </Box>
              <Box>
                <Styled.h1
                  sx={{
                    fontSize: [4,6]
                  }}>
                  <span sx={{ color: 'primary' }}>{referralProgram.title.split(" ")[0]}</span>
                  {' '}
                  <span sx={{ color: 'gray.6' }}>{referralProgram.title.split(" ").slice(1).join(" ")}</span>
                </Styled.h1>
              </Box>
            </Flex>
          </Flex>
        </PageIntro>
      </section>
      <section
        sx={{
          pt: [7, 5],
          pb: [0, 5],
          backgroundImage: `url('${bg.publicURL}')`,
          backgroundSize: ['contain'],
          backgroundPosition: 'right top',
          backgroundRepeat: 'no-repeat'
        }}>
        <Container
          sx={{
            px: 4,
            position: 'relative',
          }}>
          <Flex
            sx={{
              justifyContent: 'flex-start',
              mx: -4,
              mb: 4
            }}>
            <Box
              sx={{
                width: ['full', 'full', '3/4', '1/2'],
                px: [0, 4]
              }}>
              <Flex
                sx={{
                  p: 5,
                  bg: 'gray.3',
                  flexDirection: 'column',
                }}>
                <Box>
                  <Styled.h4
                    sx={{
                      color: 'primary'
                    }}>{referralProgram.reward.title}</Styled.h4>
                </Box>
                <Box
                  sx={{
                    mb: 4
                  }}>
                  <p>{referralProgram.reward.description}</p>
                </Box>
                <Box>
                  <Flex
                    as="ul"
                    sx={{
                      m: 0,
                      p: 0,
                      flexDirection: 'column'
                    }}>
                    {referralProgram.reward.steps.map(({ id, step }, i) => (
                      <Flex
                        as="li"
                        key={id}
                        sx={{
                          mb: 4,
                          alignItems: 'flex-start'
                        }}>
                        <span
                          sx={{
                            borderRadius: 'full',
                            bg: 'primary',
                            color: 'white',
                            mr: 3,
                            mt: 1,
                            px: '10px',
                            py: '1px',
                            height: 'initial'
                          }}>{++i}</span>
                        <span>{step}</span>
                      </Flex>
                    ))}
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Flex>
        </Container>
      </section>
      <section
        sx={{
          py: [4, 6]
        }}>
        <Container
          sx={{
            px: 4
          }}>
          <Flex
            sx={{
              mb: 4,
              mx: -4
            }}>
            <Box
              sx={{
                width: 'full',
                px: 4
              }}>
              <Styled.h3
                sx={{
                  color: 'primary'
                }}>Please Complete the Form to Get Started</Styled.h3>
            </Box>
          </Flex>
          <Flex
            sx={{
              mx: -4
            }}>
            <Box
              sx={{
                width: 'full',
                px: 4
              }}>
                <ReferralForm />
            </Box>
          </Flex>
        </Container>
      </section>
    </Layout >
  )
}

export const query = graphql`
  query ReferralProgramQuery {
    bg: file( relativePath: { eq: "referral-bg.jpg" }) {
      publicURL
    }
    referralProgram: strapiReferral {
      hero {
        childImageSharp {
          fluid(maxWidth: 1800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      id
      title
      reward {
        title
        description
        steps {
          id
          step
        }
      }
    }
  } 
`

export default ReferralProgram
